import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowUpDownOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="m6.636 2 5.637 5.636L11 8.91 7.537 5.446V21h-1.8V5.445L2.273 8.91 1 7.636z" fill="currentColor" />
            <path
                d="M17.364 22 23 16.364l-1.273-1.273-3.463 3.463V3h-1.8v15.555L13 15.09l-1.273 1.273z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArrowUpDownOutlinedSize24Glyph.displayName = 'ArrowUpDownOutlinedSize24Glyph';
